<script lang="ts">
import { defineComponent } from 'vue';
import Pagination from '@/components/pagination.vue';
import { mapActions, mapState, mapWritableState } from 'pinia';
import { usePoolsStore } from '@/stores/pools';
import { validateNumber } from '@/components/pools/helpers';
import CategoriesAdd from '@/components/pools/pool-types/categories-add.vue';
import TableFiller from '@/components/table-filler.vue';

export default defineComponent({
  name: 'categories',
  components: { TableFiller, CategoriesAdd, Pagination },
  computed: {
    ...mapState(usePoolsStore, ['poolTypes', 'poolTypeCategories', 'currentPoolTypeId']),
    ...mapWritableState(usePoolsStore, ['categoriesOffset', 'categoriesCount', 'categoriesSize']),
  },
  data() {
    return {
      showAddCategory: false,
    };
  },
  methods: {
    validateNumber,
    ...mapActions(usePoolsStore, ['fetchPoolTypeCategories', 'deletePoolTypeCategory']),
    flipCategoriesPage(newOffset: number) {
      this.categoriesOffset = newOffset;
      this.fetchPoolTypeCategories();
    },
  },
  watch: {
    currentPoolTypeId(newId: number) {
      if (newId !== null) this.fetchPoolTypeCategories();
    },
  },
});
</script>

<template>
  <template v-if="currentPoolTypeId">
    <div class="my-2">
      Распределение пула типа "{{ poolTypes!.find(({ id }) => id === currentPoolTypeId)?.name }}"
      <span class="text-gray-500">[{{ currentPoolTypeId }}]</span>
    </div>

    <table class="basic-table">
      <thead>
        <tr>
          <th>ID</th>
          <th>Отмененных</th>
          <th>Угаданных</th>
          <th>Пула, %</th>
          <th>Джекпот, %</th>
          <th>Перераспределяется, %</th>
          <th><i class="pi pi-cog" /></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="category of poolTypeCategories" v-if="poolTypeCategories">
          <td>{{ category.id }}</td>
          <td>{{ category.voidedCount }}</td>
          <td>{{ category.guessedCount }}</td>
          <td>{{ category.poolPercentage }}</td>
          <td>{{ category.jackpotPercentage }}</td>
          <td>{{ category.sharePercentage }}</td>
          <td><i
            class="pi pi-trash text-red-500 text- cursor-pointer text-[12px]"
            @click="deletePoolTypeCategory(category.id)"
          /></td>
        </tr>
        <table-filler :max="categoriesSize" :rows="poolTypeCategories || []" textSize="!text-xs"/>
        <categories-add />
      </tbody>
    </table>
    <div class="text-center">
      <Pagination
        :offset="categoriesOffset"
        :size="categoriesSize"
        :count="categoriesCount"
        @flip="flipCategoriesPage"
      />
    </div>
  </template>
</template>

<style scoped lang="scss"></style>
